<template>
  <div class="vip-c-view">
    <div class="vip-c-list" :class="listType === item.key ? 'active' : ''" v-for="item in tabs" :key="item.key" @click="listTypeChange(item.key)">
      <img :src="item.icon + 'jin0.png'" alt="">
      <img :src="item.icon + 'yin0.png'" alt="">
      <img :src="item.icon + 'tong0.png'" alt="">
      <span>{{item.name}}</span>
    </div>
  </div>
</template>

<script>
import {DomainService} from '@/libs';

export default {
  props: {
    listType: { default: '' }
  },
  data() {
    return {
      tabs: [
        { name: '推荐平台供应商', key: 'vipLevel32', icon: DomainService.PublicPath + 'resource/images/icon/' },
        // { name: '银牌供应商', key: 'vipLevel4', icon: DomainService.PublicPath + 'resource/images/icon/yin0.png' },
        // { name: '铜牌供应商', key: 'vipLevel2', icon: DomainService.PublicPath + 'resource/images/icon/tong0.png' },
      ]
    }
  },
  methods: {
    listTypeChange(value) {
      value === this.listType && (value = '');
      this.$emit('listTypeChange', value);
    }
  },
}
</script>

<style lang="less" scoped>
  .vip-c-view{
    position: absolute;
    right: 0;
    top: 0;
    height: 43px;
    display: flex;
    align-items: center;
    padding-right: 12px;
  }
  .vip-c-list{
    height: 31px;
    border-radius: 16px;
    font-size: 14px;
    color: #999999;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 12px;
    cursor: pointer;
    img{
      height: 15px;
      margin-right: 4px;
    }
  }
  .vip-c-list.active{
    background: rgba(9, 137, 197, 0.1);
    color: #0989C5;
    font-weight: bold;
  }
</style>
